module.exports = __webpack_public_path__ + "img/Pic_Ks_SZLL.71db7de2.png";